import { render, staticRenderFns } from "./filter.vue?vue&type=template&id=bec3df88"
import script from "./filter.vue?vue&type=script&lang=ts"
export * from "./filter.vue?vue&type=script&lang=ts"
import style0 from "./filter.vue?vue&type=style&index=0&id=bec3df88&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiIconSearch: require('/vercel/path0/components/ui/icon/search.vue').default,FilterAddress: require('/vercel/path0/components/filter/address.vue').default,UiIconCalendar: require('/vercel/path0/components/ui/icon/calendar.vue').default,FilterCalendar: require('/vercel/path0/components/filter/calendar.vue').default,UiIconPeople: require('/vercel/path0/components/ui/icon/people.vue').default,FilterPerson: require('/vercel/path0/components/filter/person.vue').default,ChefExtraCard: require('/vercel/path0/components/chef/extra-card.vue').default,ChefPricingCard: require('/vercel/path0/components/chef/pricing-card.vue').default})
